export const SET_USER_STATUS = 'SET_USER_STATUS'
export const SET_USER_CARDS = 'SET_USER_CARDS'
export const SELECT_USER_CARD = 'SELECT_USER_CARD'
export const DELETE_USER_CARD = 'DELETE_USER_CARD'
export const TOGGLE_OTP_MODAL = 'TOGGLE_OTP_MODAL'
export const FEE_CALCULATION_RUNNING = 'FEE_CALCULATION_RUNNING'
export const IPAY_FEE = 'IPAY_FEE'
export const SET_IPAY_ACTION_LINK = 'SET_IPAY_ACTION_LINK'
export const SET_IPAY_ACTION_LINK_RUNNING = 'SET_IPAY_ACTION_LINK_RUNNING'
